import BaseItemSerializer from './base-item';

export default class TfoSerializer extends BaseItemSerializer {}
